import { render, staticRenderFns } from "./BaskoNextGenPostCategories.vue?vue&type=template&id=0f75e4bf&scoped=true&"
import script from "./BaskoNextGenPostCategories.vue?vue&type=script&lang=js&"
export * from "./BaskoNextGenPostCategories.vue?vue&type=script&lang=js&"
import style0 from "./BaskoNextGenPostCategories.vue?vue&type=style&index=0&id=0f75e4bf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f75e4bf",
  null
  
)

export default component.exports